export const ar = {
  myDay: {
    title: "يومي",
    emptyDetails: "حدد نشاطًا لعرض التفاصيل",
  },
  list: {
    defaultEmptyText: "حدد نشاطًا",
    refreshTitle: "تحديث المهام",
    refreshAriaLabel: "تحديث المهام",
  },
  table: {
    empty: "لا توجد مهام",
    selectAllAriaLabel: "تحديد جميع المهام",
    selectActivityAria: "تحديد المهمة {{reference}}",
    unknownCustomer: "غير معروف",
    overdueAria: "متأخر",
    highValueAria: "قيمة عالية",
    columns: {
      customer: "العميل",
      reference: "المرجع",
      reason: "السبب",
      value: "القيمة",
      waiting: "بانتظار",
      finalStatus: "الحالة النهائية",
      remainingSnooze: "التأجيل المتبقي",
      priority: "الأولوية",
      assignee: "معينة الى",
    },
    outcomeMaybeDone: "قد تكون النتيجة مكتملة بالفعل",
    triggerValueWarning: "لم تعد شروط التشغيل مطابقة",
    waitingTooltip: "بانتظار {{waiting}} ({{overdue}} تجاوز الحد)",
    snoozeUntilTooltip: "حتى {{dateTime}}",
  },
  timeline: {
    today: "اليوم",
    yesterday: "أمس",
    justNow: "الآن",
    eventFallback: "حدث",
    activityCreated: "تم إنشاء المهمة",
    userAddedNote: "أضاف {{author}} ملاحظة",
    noteAdded: "تمت إضافة ملاحظة",
    assigneeMe: "بي",
    assignedToMe: " مُعيَّن إليك",
    assignedToSomeone: "مُعيَّن إلى {{name}}",
    userAssignedTo: "عيّن {{author}} إلى {{name}}",
    assigneeSomeone: "شخص ما",
    userSetNextFollowUp: "حدد {{author}} المتابعة التالية",
    userSetNextFollowUpToDate: "حدد {{author}} المتابعة التالية إلى {{date}}",
    nextFollowUp: "المتابعة التالية",
    nextFollowUpToDate: "المتابعة التالية {{date}}",
    userCompleted: "أكمل {{author}} هذا المهمة",
    completed: "مكتمل",
    userReopened: "أعاد {{author}} فتح هذا المهمة",
    reopened: "تمت إعادة الفتح",
    userSetOutcome: "حدد {{author}} النتيجة إلى {{outcome}}",
    outcomeSetTo: "تم تعيين النتيجة إلى {{outcome}}",
    eventCreated: "تم الإنشاء",
    eventNoteAdded: "إضافة ملاحظة",
    eventSnoozed: "تأجيل",
    eventCompleted: "مكتمل",
    eventReopened: "إعادة فتح",
    eventAssigned: "تعيين",
    eventOutcomeSet: "تعيين النتيجة",
    triggerValueDrifted: "لم يعد هذا ال{{entity}} يطابق شروط التشغيل",
    triggerValueRestored: "هذا ال{{entity}} يطابق شروط التشغيل مرة أخرى",
    userEventLabel: "{{author}} — {{event}}",
    empty: "لا توجد أحداث نشاط بعد",
    heading: "المهمة",
    nextFollowUpLabel: "المتابعة التالية:",
    you: "أنت",
    previousUser: "مستخدم سابق",
    deletedLabel: "تمت إزالته",
  },
  detail: {
    assignToMe: "تعيين إليّ",
  },
  items: {
    empty: "لا توجد عناصر",
  },
  notes: {
    openInShopify: "فتح في Shopify",
    outcomeHeading: "النتيجة",
    noOutcomeSet: "لم يتم تعيين نتيجة",
    reopenNotePlaceholder: "أضف ملاحظة (اختياري)...",
    reopenNoteLabel: "ملاحظة إعادة الفتح",
    reopening: "جارٍ إعادة الفتح...",
    reopenActivity: "إعادة فتح المهمة",
    addUpdateHeading: "إضافة تحديث",
    outcomeLabel: "النتيجة:",
    outcomeSelectPlaceholder: "اختر...",
    nextFollowUpLabel: "المتابعة التالية:",
    notePlaceholder: "أضف ملاحظة...",
    noteLabel: "إضافة ملاحظة",
    saveNote: "حفظ الملاحظة",
    saveAndComplete: "حفظ وإكمال",
    saveAndSnooze: "حفظ وتأجيل",
    complete: "إكمال",
    snooze: "تأجيل",
    noteTab: "ملاحظة",
    noteRequired: "ملاحظة (مطلوب)",
    completing: "جارٍ الإكمال...",
    snoozing: "جارٍ التأجيل...",
    saving: "جارٍ الحفظ...",
    completeTask: "إكمال المهمة",
    snoozeTask: "تأجيل المهمة",
    validation: {
      outcomeRequired: "يرجى اختيار النتيجة لإكمال العملية",
      followUpRequired: "يرجى اختيار تاريخ المتابعة التالية لإكمال العملية",
      noteRequired: "يرجى إدخال ملاحظة لإكمال العملية",
      reopenRequired: "يجب إدخال ملاحظة لإعادة فتح المهمة",
    },
  },
  filters: {
    clear: "مسح",
    unknownUser: "غير معروف",
    unknownTeam: "غير معروف",
    assigneePlaceholder: "معينة الى",
    searchUsersPlaceholder: "ابحث عن المستخدمين...",
    noUsersFound: "لم يتم العثور على مستخدمين",
    teamPlaceholder: "الفريق",
    searchTeamsPlaceholder: "ابحث عن الفرق...",
    noTeamsFound: "لم يتم العثور على فرق",
    preferences: "التفضيلات",
    rules: "القواعد",
    emptyHighValue: "لا توجد أنشطة عالية القيمة مطابقة لهذا الفلتر.",
    emptyVIP: "لا توجد أنشطة (VIP) مطابقة لهذا الفلتر.",
    emptyHighPriority: "لا توجد أنشطة عالية الأولوية مطابقة لهذا الفلتر.",
    threholdsHintTxt: "تتم إدارة هذا الحد بواسطة مسؤول مساحة العمل الخاصة بك. تواصل مع المسؤول إذا كنت بحاجة إلى تغييره.",
    triggersHintTxt: "تتم إدارة الأولويات في قواعد المشغلات بواسطة مسؤول مساحة العمل الخاصة بك. تواصل مع المسؤول إذا كنت بحاجة إلى تغييرها.",
    configureIn: "إعداد في"
  },
  detailHeader: {
    closeTitle: "إغلاق",
    accessDeniedTitle: "تم رفض الوصول",
    accessDeniedMessage: "ليست لديك صلاحية للوصول إلى هذا النشاط. إنه يخص فريقًا آخر.",
    accessDeniedStatus: "وصول مقيد",
    accessDeniedHint: "إذا كنت تعتقد أن هذا خطأ، تواصل مع مسؤول مساحة العمل.",
    accessDeniedDismiss: "العودة إلى القائمة",
    snoozeUntilTooltip: "حتى {{dateTime}}",
    completed: "مكتمل",
    overdueBy: "متأخر بـ {{waiting}}",
    waiting: "بانتظار {{waiting}}",
    unknownCustomer: "عميل غير معروف",
    assignedTo: "مُعيَّن إلى ",
    unassigned: "غير معيَّن",
    draftOrderConverted: "تم تحويل الطلب المسودة إلى طلب ",
    checkoutCompleted: "اكتملت السلة إلى طلب ",
    viewDetails: "عرض التفاصيل",
    orderFulfilled: "تم تنفيذ الطلب بالفعل",
    triggerValueWarning: "لم يعد هذا ال{{entity}} يطابق شروط التشغيل",
  },
  overview: {
    overdueAlert: "هذا المهمة متأخر ويتطلب اهتمامًا",
    highValueAlert: "طلب ذو قيمة عالية — أعطِ أولوية للمتابعة",
    vipAlert: "عميل VIP — أعطِ أولوية للمتابعة",
    triggerValueWarning: "لم يعد {{entity}} يطابق شروط التشغيل التي أنشأت هذه المهمة — قد تكون القيم قد تغيرت.",
    whyAppearedHeading: "لماذا ظهر هذا",
    customerHeading: "العميل",
    orderSnapshotHeading: "ملخص الطلب",
    fields: {
      name: "الاسم",
      phone: "الهاتف",
      shippingPhone: "هاتف الشحن",
      email: "البريد الإلكتروني",
      lifetimeSales: "إجمالي المبيعات",
      orders: "الطلبات",
      reference: "المرجع",
      total: "الإجمالي",
      payment: "الدفع",
      items: "الأصناف",
    },
  },
  summary: {
    assignedToYou: "مُعيَّن إليك",
    highValue: "قيمة عالية",
    highPriority: "أولوية عالية",
    overdue: "متأخر",
    vip: "VIP",
    filterAriaLabel: "تصفية المهام",
    clearAll: "مسح الكل",
    removeFilterAriaLabel: "إزالة الفلتر",
  },
  pagination: {
    itemLabel: "أنشطة",
  },
  bulk: {
    selectedOne: "تم تحديد {{count}} نشاط",
    selectedMany: "تم تحديد {{count}} مهام",
    delete: "حذف",
    deleteDialogTitleOne: "حذف {{count}} نشاط",
    deleteDialogTitleMany: "حذف {{count}} مهام",
    deleteDialogDescriptionOne: "لا يمكن التراجع عن هذا الإجراء. سيتم حذف {{count}} نشاط بشكل دائم مع جميع الأحداث المرتبطة به.",
    deleteDialogDescriptionMany: "لا يمكن التراجع عن هذا الإجراء. سيتم حذف {{count}} مهام بشكل دائم مع جميع الأحداث المرتبطة بها.",
    cancel: "إلغاء",
    deleteConfirm: "حذف",
  },
  bulkAssign: {
    assignTo: "تعيين إلى",
    searchPlaceholder: "ابحث عن المبيعات...",
    noUsersFound: "لم يتم العثور على مستخدمين",
    unknownUser: "غير معروف",
    defaultRole: "مندوب",
  },
  assign: {
    assign: "تعيين",
    searchPlaceholder: "ابحث عن المستخدمين...",
    noUsersFound: "لم يتم العثور على مستخدمين",
    unknownUser: "غير معروف",
    defaultRole: "مندوب",
  },
  tabs: {
    overview: "نظرة عامة",
    items: "الأصناف",
    notes: "ملاحظات",
    orders: "الطلبات",
  },
  entityTypes: {
    order: "طلب",
    draft_order: "طلب مسودة",
    checkout: "سلة",
  },
  driftReasons: {
    payment_method_not_allowed: "طريقة الدفع \"{{actual}}\" غير مسموح بها (المتوقع: {{expected}})",
    order_total_below_min: "إجمالي الطلب {{actual}} أقل من الحد الأدنى {{min}}",
    order_source_not_allowed: "مصدر الطلب \"{{actual}}\" غير مسموح به (المتوقع: {{expected}})",
    missing_required_tag: "تنقص وسم مطلوب (يحتاج أحد: {{expected}})",
    has_excluded_tag: "يحتوي وسم مستبعد: {{tags}}",
    draft_total_below_min: "إجمالي المسودة {{actual}} أقل من الحد الأدنى {{min}}",
    draft_no_phone: "المسودة ليس بها رقم هاتف",
    checkout_total_below_min: "إجمالي السلة {{actual}} أقل من الحد الأدنى {{min}}",
    checkout_no_phone: "العميل لم يدخل رقم هاتف",
    checkout_not_returning: "العميل ليس عميلاً عائداً",
    checkout_source_not_allowed: "مصدر السلة \"{{actual}}\" غير مسموح به (المتوقع: {{expected}})",
    checkout_step_not_reached: "السلة وصلت فقط إلى \"{{actual}}\" (المتوقع أحد: {{expected}})",
    customer_required_for_tags: "العميل مطلوب لشروط الوسوم المحددة ولكنه مفقود",
    customer_record_missing: "سجل العميل مفقود لشروط الوسوم المحددة",
    missing_required_customer_tag: "تنقص وسم عميل مطلوب (يحتاج أحد: {{expected}})",
    has_excluded_customer_tag: "يحتوي وسم عميل مستبعد: {{tags}}",
  },
  paymentMethods: {
    cash_on_delivery: "الدفع عند الاستلام",
    credit_card: "بطاقة ائتمان",
    paypal: "PayPal",
    bank_transfer: "تحويل بنكي",
    manual: "يدوي",
    other: "أخرى",
  },
  reasons: {
    codConfirmation: "طلب {{paymentMethod}} {{reference}} يحتاج إلى تأكيد ({{currency}} {{total}})",
    draftOrder: "طلب مسودة {{reference}} ({{currency}} {{total}})",
    abandonedCheckout: "سلة متروكة {{reference}} ({{currency}} {{total}})",
  },
  toasts: {
    saveNoteFailed: "فشل حفظ الملاحظة. حاول مرة أخرى.",
    snoozeFailed: "فشل تأجيل المهمة. حاول مرة أخرى.",
    completeFailed: "فشل إكمال المهمة. حاول مرة أخرى.",
  },
} as const;
